"use client";

import { useEffect, useRef, useState } from "react";
import { isProduction } from "utils/ssr";
const FORM_SRC = isProduction() ? "/travel-agent-form.html" : "/travel-agent-form.dev.html";
const TravelAgentSignupForm = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState(800);
  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (e.source !== iframeRef.current?.contentWindow) return;
      const data = (e.data as {
        type?: string;
        height?: number;
      } | null);
      if (data?.type === "ta-form-height" && typeof data.height === "number") {
        setHeight(Math.max(data.height, 200));
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);
  return <iframe ref={iframeRef} title='Travel Advisor Signup Form' src={FORM_SRC} className='w-full border-0' style={{
    height
  }} scrolling='no' data-sentry-component="TravelAgentSignupForm" data-sentry-source-file="TravelAgentSignupForm.tsx" />;
};
export default TravelAgentSignupForm;